export default {
  about_language: {
    name: 'English',
    code: 'en',
  },
  routes: {
    landing: {
      hello: 'Hello!',
    },
  },
};
